import { BOOLEAN } from 'utils/boolean'

export const IN_STOCK = {
  WITH_PRODUCTS: BOOLEAN.TRUE,
  WITHOUT_PRODUCTS: BOOLEAN.FALSE,
  ALL: 'all'
}

export const hasInStockValue = (str = ''): TSFixMe => {
  return str && (IN_STOCK.WITH_PRODUCTS === str || IN_STOCK.WITHOUT_PRODUCTS === str || IN_STOCK.ALL === str)
}

export const isFilteringByInStockValue = (str = ''): TSFixMe => {
  return str && (IN_STOCK.WITH_PRODUCTS === str || IN_STOCK.WITHOUT_PRODUCTS === str)
}
